import Component from '@glimmer/component';

// empty component needs to be kept
//we have some preloading mechanisms of this component that require it
export default class SidebarRightMyworld extends Component {}
